import * as React from 'react';

import { ProductContentsSectionHeaderProps } from 'lib/themes/themes';
import { BookingWidgetThemeContext } from 'contexts/BookingWidgetThemeContext';
import { getCustomComponent } from 'components/Themes';

export const ProductContentsSectionHeader = (props: ProductContentsSectionHeaderProps) => {
  const bookingWidgetTheme = React.useContext(BookingWidgetThemeContext);

  const CustomComponent = getCustomComponent(bookingWidgetTheme, 'ProductContentsSectionHeader');

  return <CustomComponent {...props} />;
};
